package de.oevbs.kunde.kundenportal2.model.services.digiservicecard

import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

/**
* Wird an den Service übergeben, wenn die Karte angefordert wird.
*/
@Lenses
@Serializable
data class DigitalServiceCard(
    val carContract: CarContract,
    val allowPushNotifications: Boolean
) { companion object }

/**
* Datenmodell für den UI-Store, welches vom Service mit Verträgen usw initialisiert wird.
*/
@Lenses
@Serializable
data class DigitalServiceCardInit (
    val contracts: List<CarContract> = emptyList(),
    val mail: String = "",
    val selectedContract: CarContract? = null,
    val allowPushNotifications: Boolean = true
) {
    companion object {
        val validation = validation<DigitalServiceCardInit, ComponentValidationMessage> { inspector  ->
            val contract = inspector.map(DigitalServiceCardInit.selectedContract())
            if (contract.data == null) {
                add(contract.errorMessage(KupoValidationMessages.EMPTY_SELECT))
            }
        }
    }
}